module.exports = __webpack_public_path__ + "media/images/common/order_btn_l_ov-ea20ce9fc1590ba8652689bb6f9e074a.png";